import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `
      <div class="layout-footer">
        Copyright © 
        <a href="https://www.isgh.org.br/" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">ISGH</a>
        | v1.0 - Todos os direitos reservados.
      </div>` 
})
export class AppFooter {}
